module.exports = __webpack_public_path__ + "static/media/AT&T_logo_2016.b85985aa.svg";